import client from '/src/services/client.js';

export default {
    updatePassword : (data) => client.post('change/password', data)
}